const addresses = {
    1: {
        NOCLIP: "0x36B17ff04654ba7031b1a3D8eAd3016A15262287"
    }
}

export { addresses }